export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./book.vue?vue&type=template&id=01bb5f63&"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/calendar/book.vue?vue&type=template&id=01bb5f63&
// module id = 333
// module chunks = 2